import { emojis, shortcodeToEmoji } from '@tiptap-pro/extension-emoji';
import classNames from 'classnames';

import { SerializeTextLeaf } from '../textLeaf/Text';
import { emoji } from './Emoji.css';
import type { EmojiProps } from './Emoji.types';

const Emoji = ({ element, children }: EmojiProps) => {
  const { name } = element?.attrs || {};

  const emojiAsText = name ? shortcodeToEmoji(name, emojis)?.emoji : name;

  if (!emojiAsText) {
    return null;
  }

  return (
    <SerializeTextLeaf
      leaf={{
        text: emojiAsText,
      }}
      className={classNames(emoji)}
    >
      {children}
    </SerializeTextLeaf>
  );
};

export { Emoji };
